exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".user-logo {\n  margin-bottom: 20px;\n}\n\n.delete_image {\n  cursor: pointer;\n  background: transparent;\n  position: absolute;\n  right: 50%;\n}\n\n.delete_image h1 {\n  color: #888888;\n  font-size: 24px;\n  right: -25px;\n}\n\ninput {\n  display: block;\n  width: 100%;\n  height: 38px;\n  padding: 8px 12px;\n  margin-bottom: 10px;\n  font-size: 14px;\n  line-height: 1.42857143;\n  color: #333;\n  vertical-align: middle;\n  background-color: #fff;\n  border: 1px solid #ccc;\n  border-radius: 3px;\n}\n\n.logo-preview {\n  margin-bottom: 20px;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/matthijs/projects/PHILIPS/philips-dental-pro/shop/src/app/components/account-management/account-image-upload/account-image-upload.component.scss
// module id = ../../../../../src/app/components/account-management/account-image-upload/account-image-upload.component.scss
// module chunks = main